import AssetsUnderAdviceGrid from "../../features/assetsunderadvicegrid";
import { AssetViewTypes } from "../../features/assetsunderadvicegrid/hooks/AssetsUnderAdviceContext";

const HoldingsSummaryPage = () => (
    <section className="px-4 my-3 h-100">
        <AssetsUnderAdviceGrid viewType={AssetViewTypes.HoldingsSummary} />
    </section>
);

export default HoldingsSummaryPage;